<!--MaxDiff带答案渲染-->
<template>
  <div class="question-container" style="border: 1px solid #edeff2">
    <div class="question-type">MaxDiff</div>
    <div class="title-view" :style="{ marginRight: '' }">
      <!-- <p style="color: #4c4a56">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        {{ `${dataObj.questionIndex ? dataObj.questionIndex : index + 1}、` }}
        <span style="color: #4c4a56">{{ dataObj.caseProblem }}</span>
      </p> -->
      <p class="question-row">
        <span v-if="dataObj.isMust === 1" class="asterisk">*</span>
        <span class="index">{{
          `${dataObj.questionIndex || index + 1}、`
        }}</span>

        <!-- 富文本 + 后缀文字 放在同一个容器里 -->
        <span class="rich-text-wrapper">
          <span class="rich-text-content" v-html="dataObj.caseProblem"></span>
        </span>
      </p>
    </div>

    <div class="question-images">
      <div
        v-for="(item, idx) in images"
        :key="idx"
        style="margin-top: 10px; position: relative"
      >
        <img :src="item" mode="widthFix" style="width: 100%" />
      </div>
    </div>

    <div class="options">
      <div class="option-table">
        <div class="option-table-header">
          <div class="option-table-cell">
            <input class="option-input" disabled />
          </div>
          <div class="option-table-cell">
            <input v-model="headerBest" class="option-input" disabled />
          </div>
          <div class="option-table-cell">
            <input v-model="headerWorst" class="option-input" disabled />
          </div>
        </div>

        <div class="option-table-body">
          <div
            v-for="(option, optIndex) in list"
            :key="optIndex"
            class="option-table-row"
          >
            <div class="option-table-cell">
              <div class="option-table-cell-flex">
                <div class="operation">
                  <input
                    v-model="option.context"
                    class="option-input"
                    disabled
                  />
                </div>

                <label class="radio-wrap">
                  <div
                    class="radio-box"
                    :class="{ selected: isSelected(option.id, 'best') }"
                  >
                    <div class="dot"></div>
                  </div>
                </label>

                <label class="radio-wrap">
                  <div
                    class="radio-box"
                    :class="{ selected: isSelected(option.id, 'worst') }"
                  >
                    <div class="dot"></div>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 翻页 -->
    <div class="page-control">
      <button :disabled="currentPage === 0" @click="prevPage"></button>
      <div class="page-info">{{ currentPage + 1 }}/{{ tasksNum }}</div>
      <button
        :disabled="currentPage === tasksNum - 1"
        @click="nextPage"
      ></button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      dataObj: {},
      index: 0,
      list: [],
      images: [],
      tasksNum: 0,
      attributesNum: 0,
      headerBest: "",
      headerWorst: "",

      maxDiffList: [],
      currentPage: 0,
      answerList: [],
    };
  },
  watch: {
    params: {
      handler(newVal) {
        this.dataObj = newVal.data;
        this.index = newVal.index;
        this.images = JSON.parse(newVal.data.caseProblemImg || "[]");

        const chooseList = JSON.parse(newVal.data.chooseList);
        console.log(chooseList, "chooseList.maxDiffList");
        this.maxDiffList = chooseList.maxDiffList || [];
        this.tasksNum = chooseList.tasksNum;
        this.attributesNum = chooseList.attributesNum;
        this.headerBest = chooseList.percentageTitle.split(",")[0] || "";
        this.headerWorst = chooseList.percentageTitle.split(",")[1] || "";

        if (
          newVal.answer &&
          Array.isArray(newVal.answer.answer) &&
          newVal.answer.answer.length > 0
        ) {
          this.maxDiffList = chooseList.maxDiffList || [];
          this.currentPage = 0;
          this.list = this.maxDiffList[0].list;

          this.answerList = newVal.answer.answer[0] || {};
        } else {
          this.list = chooseList.list.slice(0, this.attributesNum);
          this.answerList = {};
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    isSelected(optionId, type) {
      if (!this.answerList || this.answerList.length === 0) return false;

      const currentAnswer = this.answerList || {};
      if (type === "best") return currentAnswer.leftId == optionId;
      if (type === "worst") return currentAnswer.rightId == optionId;
      return false;
    },

    nextPage() {
      if (this.currentPage < this.maxDiffList.length - 1) {
        this.currentPage++;
        this.list = this.maxDiffList[this.currentPage].list;

        this.answerList = this.params.answer.answer[this.currentPage] || {};
      }
    },

    prevPage() {
      if (this.currentPage > 0) {
        this.currentPage--;
        this.list = this.maxDiffList[this.currentPage].list;

        this.answerList = this.params.answer.answer[this.currentPage] || {};
      }
    },
  },
};
</script>

<style scoped>
.select-view {
  width: 100%;
  min-height: 44px;
  background-color: #f9f9f9;
  border-radius: 3px;
  margin-top: 12px;
  padding: 0 12px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #ededed;
}

.options .option-table .edit {
  width: 17px;
  height: 17px;
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translate(0, -50%);
}

.options .option-table .option-table-header {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  background: #f5f7fa;
  min-height: 40px;
  border-top: 1px solid #bbbbbb;
  border-left: 1px solid #bbbbbb;
}

.options .option-table .option-table-header .option-table-cell {
  border-right: 1px solid #bbbbbb;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.options .option-table .option-table-header .option-table-cell input {
  padding: 0 30px 0 10px;
  width: 100%;
  height: 100%;
}

.options .option-table .option-table-body {
  border-bottom: 1px solid #bbbbbb;
  margin-bottom: 10px;
}

.options .option-table .option-table-body .option-table-cell {
  min-height: 40px;
}

.options
  .option-table
  .option-table-body
  .option-table-cell
  .option-table-cell-flex {
  min-height: 40px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid #bbbbbb;
  border-left: 1px solid #bbbbbb;
}

.options
  .option-table
  .option-table-body
  .option-table-cell
  .option-table-cell-flex
  .operation {
  display: flex;
  border-right: 1px solid #bbbbbb;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.options
  .option-table
  .option-table-body
  .option-table-cell
  .option-table-cell-flex
  .operation
  input {
  padding: 0 30px 0 10px;
  width: 100%;
  height: 100%;
}

.options
  .option-table
  .option-table-body
  .option-table-cell
  .option-table-cell-flex
  .operation
  .del1 {
  width: 14.5px;
  height: 12.5px;
  position: absolute;
  top: -1px;
  right: -1px;
  z-index: 5;
}

.options
  .option-table
  .option-table-body
  .option-table-cell
  .option-table-cell-flex
  .radio-wrap {
  border-right: 1px solid #bbbbbb;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.select-box {
  display: flex;
  align-items: center;
}

.select-box p {
  margin-right: 5px;
  white-space: nowrap;
  letter-spacing: -1px;
}

.radio-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
}

.radio-box {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 1px solid #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.15s;
}

.dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
}

.page-control {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 19px;
}

.page-control button {
  width: 35px;
  height: 35px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  position: relative;
  background: none;
}

.page-control button::before {
  display: block;
  content: "";
  width: 8px;
  height: 8px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  border-top: 1px solid #000;
  border-left: 1px solid #000;
  margin-left: 3px;
}

.page-control button[disabled]::before {
  border-color: #e2e2e2;
}

.page-control button:last-child::before {
  display: block;
  content: "";
  width: 8px;
  height: 8px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  border-top: none;
  border-left: none;
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  margin-left: -3px;
}

.page-control button:last-child[disabled]::before {
  border-color: #e2e2e2;
}

.page-info {
  font-size: 12px;
  color: #000;
  margin: 0 30px;
}

.selected {
  border: 1px solid #3a60ff;
  position: relative;
}

.selected::after {
  width: 70%;
  height: 70%;
  display: block;
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  background: #3a60ff;
  transform: translate(-50%, -50%);
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionPreview/QuestionPreviewMaxDiff.vue